import { IS_AUTHENTICATED, IS_NOT_AUTHENTICATED } from '../actions/security'
import { access } from '../../../security'
import { clearOrgPackageAssignments } from '../../home/helpers/orgPackages'
import { clearQcsHandoffSession } from '../helpers/qcsHandoffSession'
import { getQcsHandoffId } from '../helpers/getQcsHandoffId'
import { AUTH0_CAREPLAN_REDIRECT_FLAG, AUTH0_SESSION_PROBED_FLAG } from '../../../configs'

const SUPPORT_ACTIVE_USER_KEY = 'support_active_user'

const readStoredAuthenticated = () => {
  try {
    return JSON.parse(localStorage.getItem('authenticated')) === true
  } catch {
    return false
  }
}

const clearAuth0RedirectFlag = () => {
  try {
    sessionStorage.removeItem(AUTH0_CAREPLAN_REDIRECT_FLAG)
    sessionStorage.removeItem(AUTH0_SESSION_PROBED_FLAG)
  } catch {
    // ignore
  }
}

const clearClientSession = () => {
  access.userRole = null
  access.botAccesses = []
  try {
    localStorage.removeItem('activeBotName')
  } catch {
    // ignore
  }
  try {
    sessionStorage.removeItem(SUPPORT_ACTIVE_USER_KEY)
  } catch {
    // ignore
  }
  clearAuth0RedirectFlag()
  clearOrgPackageAssignments()
  clearQcsHandoffSession()
}

// Login owns auth on a QCS handoff link (/login or a protected path such as /admin);
// probing a leftover flag here 401s and shows "logged out" before the handoff can sign in.
const isQcsHandoffEntry = () => Boolean(getQcsHandoffId(window.location))

const initialAuthenticated = readStoredAuthenticated() && !isQcsHandoffEntry()
if (initialAuthenticated) {
  access.loadRole()
}

const security = (state = { authenticated: initialAuthenticated }, action) => {
  switch (action.type) {
  case IS_AUTHENTICATED:
    access.loadRole()
    localStorage.setItem('authenticated', 'true')
    clearAuth0RedirectFlag()
    return action.security
  case IS_NOT_AUTHENTICATED:
    localStorage.setItem('authenticated', 'false')
    clearClientSession()
    return action.security
  default:
    return state
  }
}

export default security
